<template>
  <div class="client-details py-5 ml-5">
    <p>Hi <b>{{ users.username }}</b></p>
    <p class="greetings">{{ greetings }}</p>
  </div>

  <div class="table-container">
    <v-row style="align-items: center;">
      <v-col cols="7">
        <h3 style="font-size: 24px; font-weight: 600;">Select Your Client</h3>
        <p style="font-size: 12px; font-weight: 300;">Choose the company that you want to access</p>
      </v-col>

      <v-col cols="5">
        <v-text-field v-model="search" placeholder="Search the Client" variant="outlined" hide-details
          prepend-inner-icon="mdi-magnify" density="compact" style="padding: 0; margin: 0;"></v-text-field>
      </v-col>
    </v-row>

    <v-row class="px-6 mt-8" v-if="filteredItems.length > 0">
      <input type="file" ref="fileInput" accept="image/*" style="display: none;" @change="handleFileSelect" />

      <transition-group name="card" tag="div" class="card-container d-flex flex-wrap" appear>
        <v-col cols="3" v-for="(entry, index) in filteredItems"
          :key="entry.organisation_id || entry.id || entry.organisationName || index" style="height: 60%;"
          :style="{ '--i': index }">


          <div @click="clientDetails(entry)" :class="(activeMenu === entry.organisationName || (clients && clients.length === 1))
            ? 'active'
            : 'inactive'">
            <div class="img-container">
              <v-icon v-if="role < 6" @click.stop="triggerFileInput(index, entry)"
                class="upload-img rounded-circle pa-5">
                mdi-camera-plus
              </v-icon>
              <img class="img-logo" 
                :src="entry.logo.s3Url ? entry.logo.s3Url 
                : entry.logo.src ? entry.logo.src
                : require('@/assets/image/home.png')" alt="img" />

            </div>

            <div class="organisation-details py-3">
              <v-tooltip :text="entry.organisationName" location="top">
                <template #activator="{ props }">
                  <h3 v-bind="props" style="color: #fff; font-size: 18px; font-weight: 600;">
                    {{ getTrimmedText(entry.organisationName) }}
                  </h3>
                </template>
              </v-tooltip>

              <img v-if="entry.client && entry.client.logo && entry.client.logo.length > 0" class="mt-2" width="130"
                height="40" :src="entry.client.logo[0].src" alt="" />
              <p style="color: #fff; font-size: 14px;">
                Last Modified date:
                {{ entry.modified ? formatDate(entry.modified) : formatDate(entry.created) }}
              </p>
            </div>
          </div>
        </v-col>
      </transition-group>
    </v-row>

    <v-row v-else class="mt-15">
      <p class="no-data-container">No Clients To Display</p>
    </v-row>
    <!-- <v-col class="pa-0" cols="12">
          <v-btn :disabled="showContinue"  class="mt-10" style="width: 100%; height: 40px;" color="#082fb1" @click="onContinue(organisation_id)">
              Continue
              <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col> -->
  </div>
</template>

<script>
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import ClientDocumentsService from '@/api/service/ClientDocuments/ClientDocumentsService';
import moment from "moment";

export default {
  components: {
  },
  data() {
    return {
      userDetails: localStorage.getItem('user_details'),
      users: '',
      clients: [],
      id: null,
      logo: '',
      currentIndex: null,
      search: '',
      showContinue: true,
      activeMenu: '',
      user_id: null,
      organisation_id: '',
      greetings: this.getGreetings(),
      role: null,
    };
  },
  created() {
    let user = localStorage.getItem('user_details')
    user = JSON.parse(user)
    this.user_id = user.id
    this.role = user.roles.role_type
  },
  methods: {
    triggerFileInput(index, id) {
      this.id = id
      this.currentIndex = index
      this.$refs.fileInput.click();
    },

    async handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = async (e) => {
        let now = moment().format('YYYY-MM-DD HH:mm:ss')
        const imageBase64 = e.target.result;
        this.logo = {
          // id: this.client.logo.length + 1,
          src: imageBase64,  
          created: now,
          modified: now,
          created_by: this.user_id,  
          modified_by: this.user_id,
          active: 1,
          deleted: 0,
          deleted_by: null     
        }
        let $json = {
          collectionName: 'documents',
          name: file.name,
          doc_name: file.name,
          file_name: file.name,
          key_type: "uploadFiles",
          key_id: this.id._id,
          file_type: file.type,
          active: 1,
          src: imageBase64,
          profile:true
        };
        const docData = await ClientDocumentsService.create($json)
        console.log("Base64 Image:", docData);
        this.logo.docid = docData.data.data._id
        this.logo.s3Url = docData.data.data.s3Url
        console.log("Base64 Image 1:", this.logo);
        this.clients[this.currentIndex].logo = this.logo

        await this.save()
      };
      reader.readAsDataURL(file);
    },

    async save() {
      this.clients[this.currentIndex].logo = this.logo
      let $data = {
        collectionName: 'organisation',
        data: this.clients[this.currentIndex],
        id: this.id._id
      }
      
      await clientDetailsService.update($data)
    },

    getTrimmedText(text) {
      return text && text.length <= 20 ? text : text && text.slice(0, 20) + ' ...';
    },
    getUsers() {
      this.users = JSON.parse(this.userDetails)
    },

    async getClient() {
      let res = await clientDetailsService.findAll({ collectionName: 'organisation' })
      this.clients = res.length > 0 ? res : []
      if (this.clients && this.clients.length == 1) {
        this.clientDetails(this.clients[0])
        this.showContinue = false
      }
      console.log(this.clients, "this.clients!!")
    },
    async getSchema() {
      let res = await clientDetailsService.getSchemaList({ collectionName: 'organisation' })
      console.log(res, 'shemalistjj3r3rm3')
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    getGreetings() {
      const hour = moment().hour();
      if (hour < 12) {
        return "Good Morning"
      }
      else if (hour < 17) {
        return "Good Afternoon"
      }
      else {
        return "Good Evening"
      }
    },
    clientDetails($data) {
      console.log($data, 'data!!')
      this.showContinue = false
      this.activeMenu = $data.organisationName
      this.organisation_id = $data._id
      this.onContinue($data._id)

    },

    onContinue($data) {
      console.log($data, "oncontinue")
      this.$router.push({
        path: "/ClientDetails/aboutclient",
        query: { id: $data },
      })
    }
  },
  mounted() {
    this.getUsers()
    this.getClient()
    this.getSchema()
  },

  computed: {
    filteredItems() {
      const q = this.search.toLowerCase();
      let results = this.clients.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(q)
        )
      );
      // if(q == ''){
      //   this.showContinue = true
      // } else {
      //   this.showContinue = false
      //   this.clientDetails(results[0])
      // }

      return results
    },
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  position: relative;
  // display: inline-block;
}

.upload-img {
  position: absolute;
  top: 5px;
  right: 8px;
  color: #1976d2;
  font-size: 28px;
  cursor: pointer;
  transition: 0.3s;
}

.active {
  border: 3px solid #082fb1;
  padding: 0 !important;
  // width: 220px;
  height: 100%;
  border-radius: 11px;
}

.inactive {
  border: 3px solid #9B9B9B;
  padding: 0 !important;
  // width: 220px;
  height: 100%;
  border-radius: 11px;
}

.img-logo {
  width: 100%;
  height: 247px;
  // height: 100%;
  border-radius: 9px;
  // border-bottom-left-radius: 10px;
  // border-bottom-right-radius: 10px;
}

.organisation-details {
  min-height: 122px;
  position: relative;
  bottom: 129px;
  border-bottom-right-radius: 7px;
  border-bottom-left-radius: 7px;
  padding-left: 11px;
  background-color: #00000042;
}

.greetings {
  color: rgb(18, 88, 171);
  font-weight: 600;
}

.card-container {
  display: flex;
  min-height: 460px;
  max-height: 460px;
  overflow-y: auto;
  flex-wrap: wrap;
  width: 100%;
}

.table-container {
  width: 100%;
  padding: 8px 15px;
  border-radius: 4px;
}

.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250%;
  height: 400px;
  font-size: 20px;
  font-weight: 500;
}

.card-enter-active,
.card-leave-active {
  transition: opacity 700ms cubic-bezier(.25, .9, .25, 1),
    transform 700ms cubic-bezier(.25, .9, .25, 1);
  transition-delay: calc(var(--i, 0) * 100ms);
}

.card-enter-from {
  opacity: 0;
  transform: translateY(25px) scale(0.97);
}

.card-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(0.97);
}

.card-move {
  transition: transform 700ms cubic-bezier(.25, .9, .25, 1);
}
</style>